module.exports = __webpack_public_path__ + "static/media/avatar14.3502706d.png";